var order = {
  status: {
    // 虚拟物品，无拼团
    virtual_0: [{
      condition: {
        order_status: 1,
        pay_status: 1
      },
      descID: 1
    }, {
      condition: {
        order_status: 2,
        pay_status: 2
      },
      descID: 5
    }, {
      condition: [{
        order_status: 1,
        pay_status: 3
      }, {
        order_status: 2,
        pay_status: 3
      }],
      descID: 7
    }, {
      condition: [{
        order_status: 1,
        pay_status: 4
      }, {
        order_status: 2,
        pay_status: 4
      }],
      descID: 8
    }, {
      condition: [{
        order_status: 1,
        pay_status: 6
      }, {
        order_status: 2,
        pay_status: 6
      }],
      descID: 9
    }, {
      condition: {
        order_status: 3,
        pay_status: 1
      },
      descID: 12
    }, {
      condition: {
        order_status: 3,
        pay_status: 5
      },
      descID: 10
    }, {
      condition: {
        order_status: 1,
        pay_status: 8
      },
      descID: 4
    }, {
      condition: {
        order_status: 2,
        pay_status: 8
      },
      descID: 14
    }, {
      condition: {
        order_status: 2,
        pay_status: 5
      },
      descID: 15
    }],
    // 实体物品，无拼团
    entity_0: [{
      condition: [{
        order_status: 1,
        pay_status: 2,
        ship_status: 3
      }, {
        order_status: 1,
        pay_status: 8,
        ship_status: 3
      }],
      descID: 4
    }, {
      condition: {
        order_status: 1,
        pay_status: 1
      },
      descID: 1
    }, {
      condition: [{
        order_status: 1,
        pay_status: 2,
        ship_status: 1
      }, {
        order_status: 2,
        pay_status: 8,
        ship_status: 1
      }, {
        order_status: 1,
        pay_status: 8,
        ship_status: 1
      }],
      descID: 3
    }, {
      condition: {
        order_status: 2,
        pay_status: 2
      },
      descID: 5
    }, {
      condition: [{
        order_status: 1,
        pay_status: 3
      }, {
        order_status: 2,
        pay_status: 3
      }],
      descID: 7
    }, {
      condition: [{
        order_status: 1,
        pay_status: 4
      }, {
        order_status: 2,
        pay_status: 4
      }],
      descID: 8
    }, {
      condition: [{
        order_status: 1,
        pay_status: 6
      }, {
        order_status: 2,
        pay_status: 6
      }],
      descID: 9
    }, {
      condition: {
        order_status: 3,
        pay_status: 1
      },
      descID: 12
    }, {
      condition: {
        order_status: 3,
        pay_status: 5
      },
      descID: 10
    }, {
      condition: [{
        order_status: 2,
        pay_status: 8,
        ship_status: 2
      }, {
        order_status: 2,
        pay_status: 8,
        ship_status: 3
      }, {
        order_status: 2,
        pay_status: 8,
        ship_status: 4
      }],
      descID: 14
    }, {
      condition: {
        order_status: 2,
        pay_status: 5
      },
      descID: 15
    }],
    // 虚拟物品，有拼团
    virtual_1: [{
      condition: {
        order_status: 1,
        pay_status: 1
      },
      descID: 1
    }, {
      condition: {
        order_status: 1,
        pay_status: 2,
        group_status: 2
      },
      descID: 2
    }, {
      condition: {
        order_status: 2,
        pay_status: 2,
        group_status: 1
      },
      descID: 6
    }, {
      condition: [{
        order_status: 1,
        pay_status: 3
      }, {
        order_status: 2,
        pay_status: 3
      }],
      descID: 7
    }, {
      condition: [{
        order_status: 1,
        pay_status: 4
      }, {
        order_status: 2,
        pay_status: 4
      }],
      descID: 8
    }, {
      condition: [{
        order_status: 1,
        pay_status: 6
      }, {
        order_status: 2,
        pay_status: 6
      }],
      descID: 9
    }, {
      condition: [{
        order_status: 3,
        pay_status: 5,
        group_status: 1
      }, {
        order_status: 3,
        pay_status: 5,
        group_status: null
      }],
      descID: 10
    }, {
      condition: [{
        order_status: 3,
        pay_status: 2,
        group_status: 3
      }, {
        order_status: 3,
        pay_status: 5,
        group_status: 3
      }],
      descID: 11
    }, {
      condition: {
        order_status: 3,
        pay_status: 1
      },
      descID: 12
    }, {
      condition: {
        order_status: 2,
        pay_status: 8
      },
      descID: 14
    }, {
      condition: {
        order_status: 2,
        pay_status: 5
      },
      descID: 15
    }],
    // 实体物品，有拼团
    entity_1: [{
      condition: {
        order_status: 1,
        pay_status: 1
      },
      descID: 1
    }, {
      condition: {
        order_status: 1,
        pay_status: 2,
        group_status: 2
      },
      descID: 2
    }, {
      condition: {
        order_status: 1,
        pay_status: 2,
        ship_status: 1,
        group_status: 1
      },
      descID: 13
    }, {
      condition: {
        order_status: 1,
        pay_status: 2,
        ship_status: 3,
        group_status: 1
      },
      descID: 4
    }, {
      condition: {
        order_status: 2,
        pay_status: 2,
        ship_status: 4,
        group_status: 1
      },
      descID: 6
    }, {
      condition: [{
        order_status: 1,
        pay_status: 3
      }, {
        order_status: 2,
        pay_status: 3
      }],
      descID: 7
    }, {
      condition: [{
        order_status: 1,
        pay_status: 4
      }, {
        order_status: 2,
        pay_status: 4
      }],
      descID: 8
    }, {
      condition: [{
        order_status: 1,
        pay_status: 6
      }, {
        order_status: 2,
        pay_status: 6
      }],
      descID: 9
    }, {
      condition: [{
        order_status: 3,
        pay_status: 5,
        group_status: 1
      }, {
        order_status: 3,
        pay_status: 5,
        group_status: null
      }],
      descID: 10
    }, {
      condition: [{
        order_status: 3,
        pay_status: 2,
        group_status: 3
      }, {
        order_status: 3,
        pay_status: 5,
        group_status: 3
      }],
      descID: 11
    }, {
      condition: {
        order_status: 3,
        pay_status: 1
      },
      descID: 12
    }, {
      condition: {
        order_status: 2,
        pay_status: 8
      },
      descID: 14
    }, {
      condition: {
        order_status: 2,
        pay_status: 5
      },
      descID: 15
    }]
  },
  desc: {
    1: {
      list: "待支付",
      detail_title: "待支付",
      detail_more: "待支付"
    },
    2: {
      copy: true,
      // 是否拷贝一份该对象，并导出；解决format后，内容重复的问题
      list: "拼团中",
      detail_title: "拼团中",
      detail_more: "拼团中"
    },
    3: {
      list: "待发货",
      detail_title: "等待商家发货",
      detail_more: "买家已付款，等待商家发货"
    },
    4: {
      list: "已发货",
      detail_title: "商家已发货"
    },
    5: {
      list: "交易完成",
      detail_title: "交易完成",
      detail_more: "订单交易完成"
    },
    6: {
      list: "已成团，交易完成",
      detail_title: "已成团，交易完成",
      detail_more: "订单交易完成"
    },
    7: {
      list: "退款申请中",
      detail_title: "退款申请中",
      detail_refund: "退款申请中"
    },
    8: {
      list: "退款中",
      detail_title: "退款中",
      detail_refund: "退款中"
    },
    9: {
      list: "退款失败",
      detail_title: "退款失败",
      detail_refund: "退款失败"
    },
    10: {
      list: "退款成功，交易关闭",
      detail_title: "交易关闭",
      detail_more: "退款成功",
      detail_refund: "退款成功"
    },
    11: {
      list: "未成团，交易关闭",
      detail_title: "交易关闭",
      detail_more: "超时未成团，系统会自动将所支付的款项原路返还"
    },
    12: {
      list: "交易取消",
      detail_title: "交易取消",
      detail_more: "交易取消"
    },
    13: {
      list: "已成团，待发货",
      detail_title: "拼团成功，等待商家发货",
      detail_more: "买家已付款，等待商家发货"
    },
    14: {
      list: "部分退款",
      detail_title: "部分退款",
      detail_more: "部分退款"
    },
    15: {
      list: "退款成功，交易关闭",
      detail_title: "交易关闭",
      detail_more: "退款成功",
      detail_refund: "退款成功"
    }
  }
}; // 检测条件

function checkCondition(data, condition) {
  var flag = true;

  for (var key in condition) {
    if (data[key] != condition[key]) {
      flag = false;
      break;
    }
  }

  return flag;
} // 获取描述


function getDesc(data, dict) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = dict[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var i = _step.value;
      var flag = false;

      if (i.condition.length) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = i.condition[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (checkCondition(data, item)) {
              flag = true;
              break;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } else {
        flag = checkCondition(data, i.condition);
      }

      if (flag) {
        var textObj = order.desc[i.descID].copy ? Object.assign({}, order.desc[i.descID]) : order.desc[i.descID];
        return {
          id: i.descID,
          text: textObj
        };
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return {
    id: 0,
    text: {}
  };
} // 获取描述数据


function getDescData(data) {
  var obj = {};

  if (!data.spell_id) {
    if (data.is_virtual == 1) obj = getDesc(data, order.status.virtual_0);else obj = getDesc(data, order.status.entity_0);
  } else if (data.is_virtual == 1) obj = getDesc(data, order.status.virtual_1);else obj = getDesc(data, order.status.entity_1);

  return obj;
}

export default {
  getListDescData: function getListDescData(data) {
    // if (data.pay_type == 6) {
    //   let status = "";
    //   if (data.order_status == 2) {
    //     status = "交易完成";
    //   } else if (data.order_status == 3) {
    //     status = "交易关闭";
    //   }
    //   return {
    //     text: {
    //       list: status
    //     }
    //   };
    // }
    var obj = getDescData(data);

    switch (obj.id) {
      case 2:
        obj.text.list = "\u62FC\u56E2\u4E2D\uFF0C\u8FD8\u5DEE".concat(data.user_num - data.join_num, "\u4EBA");
        break;
    }

    return obj;
  },
  getDetailDescData: function getDetailDescData(data) {
    var obj = getDescData(data);

    switch (obj.id) {
      case 2:
        obj.text.detail_more = "\u8FD8\u5DEE".concat(data.user_num - data.join_num, "\u4EBA\uFF0C\u9080\u8BF7\u597D\u53CB\u62FC\u56E2");
        break;
    }

    return obj;
  }
};